import debug from 'debug'

export const zeaDebug = debug('zea:collab')
